<template>
	<button class="button" data-test="button"><slot></slot></button>
</template>

<script>
export default {
	name: "AppButton"
};
</script>
